/**
 * 缩小拖放时的缩略图
 */
export function shrinkSetData(dataTransfer: DataTransfer, dragEl: HTMLElement) {
  const clone = dragEl.cloneNode(true) as HTMLElement
  const width = dragEl.clientWidth
  const height = dragEl.clientHeight
  clone.style.position = 'fixed'
  clone.style.top = `-${width}px`
  clone.style.left = `-${height}px`
  clone.style.width = `${width}px`
  clone.style.height = `${height}px`
  clone.style.paddingTop = '0'
  clone.style.paddingBottom = '0'
  clone.style.zoom = '.4'
  dragEl.after(clone)
  dataTransfer.setDragImage(clone, width * .4 / 2, height * .4 / 2)
  setTimeout(() => clone.remove())
}
